import {lazy} from 'react'

const GiftshopPackageScreen = lazy(
  () =>
    import(
      /* webpackChunkName: 'GiftshopPackageScreen' */ './GiftshopPackageScreen'
    ),
)

const GiftshopPackageContentDetailScreen = lazy(
  () =>
    import(
      /* webpackChunkName: 'GiftshopPackageContentDetailScreen' */ './GiftshopPackageContentDetailScreen'
    ),
)

export * from './GiftshopPackageScreenParam'
export * from './GiftshopPackageContentDetailScreenParam'

export {GiftshopPackageScreen, GiftshopPackageContentDetailScreen}
